import { useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { StarPicker } from "./Stars";

const INPUT =
  "w-full px-4 py-3 rounded-xl border border-[#D5CCBC] bg-white text-xs text-[#1E2B1D] focus:outline-none focus:ring-2 focus:ring-[#3D5A40]";
const LABEL = "block text-xs font-bold uppercase tracking-wider text-[#354634] mb-2";

export default function ReviewForm({ onSubmitted }) {
  const [form, setForm] = useState({ order_code: "", phone: "", rating: 0, comment: "" });
  const [submitting, setSubmitting] = useState(false);
  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    if (!form.rating) {
      toast.error("Pilih jumlah bintang terlebih dahulu");
      return;
    }
    setSubmitting(true);
    try {
      const { data } = await api.post("/reviews", form);
      toast.success("Terima kasih! Ulasan Anda sudah tayang.");
      setForm({ order_code: "", phone: "", rating: 0, comment: "" });
      onSubmitted?.(data);
    } catch (err) {
      const detail = err.response?.data?.detail;
      toast.error(typeof detail === "string" ? detail : "Gagal mengirim ulasan, coba lagi");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <form onSubmit={submit} data-testid="review-form" className="bg-[#FBF9F5] rounded-3xl border border-[#DACFBE] p-6 sm:p-8 shadow-md space-y-5">
      <div>
        <h3 className="font-serif-display text-2xl text-[#1E2B1D]">Tulis Ulasan Anda</h3>
        <p className="text-xs text-[#5E6D5B] mt-1">
          Khusus pembeli dengan pesanan berstatus <span className="font-semibold">Selesai</span>. Masukkan kode pesanan dan nomor kontak yang dipakai saat checkout.
        </p>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div>
          <label className={LABEL}>Kode Pesanan</label>
          <input required value={form.order_code} onChange={set("order_code")} data-testid="review-order-code-input" placeholder="PF-XXXXXXXX" className={`${INPUT} font-mono uppercase`} />
        </div>
        <div>
          <label className={LABEL}>Nomor Kontak / WhatsApp</label>
          <input required value={form.phone} onChange={set("phone")} data-testid="review-phone-input" placeholder="08xxxxxxxxxx" className={INPUT} />
        </div>
      </div>
      <div>
        <label className={LABEL}>Penilaian</label>
        <StarPicker value={form.rating} onChange={(rating) => setForm((f) => ({ ...f, rating }))} />
      </div>
      <div>
        <label className={LABEL}>Ulasan</label>
        <textarea
          required
          minLength={5}
          maxLength={600}
          rows="3"
          value={form.comment}
          onChange={set("comment")}
          data-testid="review-comment-input"
          placeholder="Ceritakan pengalaman Anda: kesegaran bunga, ketepatan pengiriman, pelayanan..."
          className={INPUT}
        />
      </div>
      <button
        type="submit"
        disabled={submitting}
        data-testid="review-submit-btn"
        className="w-full sm:w-auto px-6 py-3 rounded-xl bg-[#3D5A40] hover:bg-[#2E4530] disabled:opacity-50 text-[#FAF7EE] font-bold text-sm transition-colors shadow-md"
      >
        {submitting ? "Mengirim..." : "Kirim Ulasan"}
      </button>
    </form>
  );
}
